import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { NotificationMethod } from "shared/cubiq-model-multi-asset";

export const CHANNEL_CLIENT_SERVICE: string = "ClientServiceChannel";

export interface IClientActionService {
  updateClientComments(
    clientCode: string,
    clientComment: string,
    privateComment: string,
  ): Promise<void>;
  saveClientContact(
    id: string,
    clientCd: string,
    contactName: string,
    desk: string,
    mobile: string,
    sms: string,
    email: string,
    isDefault: boolean,
    notifyEntry: NotificationMethod,
    notifyExpiry: NotificationMethod,
    notifyFill: NotificationMethod,
    notifyModify: NotificationMethod,
    notifyCancel: NotificationMethod,
  ): Promise<void>;
  deleteClientContact(clientContactId: string): Promise<void>;
  saveClientTrader(
    clientCode: string,
    comment: string,
    userName: string,
    userCode: string,
    desk: string,
    mobile: string,
    email: string,
    isDefault: boolean,
  ): Promise<void>;
  deleteClientTrader(clientCode: string, userName: string): Promise<void>;
}
